import { Modal } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';

interface Props {}

export interface ModalConfirmRef {
  open: (title: string, description: string, onSuccess?: () => void) => void;
  close: () => void;
}

const ModalConfirm = forwardRef<ModalConfirmRef, Props>(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const refSuccess = useRef<() => void>();
  const onClose = () => {
    setTitle('');
    setDescription('');
    refSuccess.current = undefined;
    setOpen(false);
  };

  const onDone = () => {
    refSuccess.current?.();
  };

  const onOpen = (title: string, description: string, onSuccess?: () => void) => {
    setOpen(true);
    setTitle(title);
    setDescription(description);
    refSuccess.current = onSuccess;
  };
  useImperativeHandle(ref, () => ({
    open: onOpen,
    close: onClose,
  }));

  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      width={511}
      centered
      destroyOnClose={false}
      closable={false}
    >
      <ContainerStyled>
        <div className='icon'>
          <IcWarning />
        </div>
        <div className='content'>
          <span className='title'>{title}</span>
          <span className='description'>{description}</span>
        </div>

        <ButtonsStyled>
          <button type='button' className='btn-cancel' onClick={onClose}>
            Close
          </button>
          <button type='button' className='btn-submit' onClick={onDone}>
            Ok
          </button>
        </ButtonsStyled>
      </ContainerStyled>
    </Modal>
  );
});

export default ModalConfirm;

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    .title {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
    .description {
      color: #566a7f;
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

const ButtonsStyled = styled.div`
  display: flex;
  gap: 16px;

  button {
    cursor: pointer;
    display: flex;
    height: 48px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;

    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border: none;
    outline: none;
    transition: all 0.3s ease;
    &.btn-cancel {
      background: #e3e9ed;
      color: #566a7f;
    }
    &.btn-submit {
      color: #fff;
      background: #ff8890;
    }
    &:hover {
      opacity: 0.8;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

const IcWarning = () => (
  <svg width='96' height='97' viewBox='0 0 96 97' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_9681_96453)'>
      <circle opacity='0.12' cx='48' cy='48.5001' r='48' fill='#FF8890' />
      <path
        d='M48 60.5001C49.6569 60.5001 51 61.8432 51 63.5001C51 65.1569 49.6569 66.5001 48 66.5001C46.3431 66.5001 45 65.1569 45 63.5001C45 61.8432 46.3431 60.5001 48 60.5001ZM48 30.5001C49.6569 30.5001 51 31.8432 51 33.5001V55.5001C51 57.1569 49.6569 58.5001 48 58.5001C46.3431 58.5001 45 57.1569 45 55.5001V33.5001C45 31.8432 46.3431 30.5001 48 30.5001Z'
        fill='#FF8890'
      />
    </g>
    <defs>
      <clipPath id='clip0_9681_96453'>
        <rect width='96' height='96' fill='white' transform='translate(0 0.500061)' />
      </clipPath>
    </defs>
  </svg>
);
